import { ScreenWrapperComponent } from 'components/layouts/ScreenWrapperComponent';
import { AdminNavigationMenu } from 'components/AdminNavigationMenu';

import './adminPageWrapper.scss';
import { ReactNode } from 'react';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { useNavigate } from 'react-router';

type AdminPageWrapperProps = {
  children: ReactNode;
  sidebar?: ReactNode;
};

export const AdminPageWrapper = ({
  children,
  sidebar,
}: AdminPageWrapperProps) => {
  const navigate = useNavigate();
  return (
    <ScreenWrapperComponent>
      <div
        className={` 
        admin-dashboard-wrapper
        ${sidebar ? 'admin-dashboard-wrapper-with-sidebar' : ''}
      `}
      >
        <div className='pj-admin-sidebar'>
          <ButtonComponent
            label='Back to Dashboard'
            appereance='primary'
            onClick={() => navigate('/home')}
            size='middle'
            fullWidth
          />
          <AdminNavigationMenu />
        </div>
        <div className='pj-admin-content'>{children}</div>
        {sidebar && <div className='pj-admin-sidebar'>{sidebar}</div>}
      </div>
    </ScreenWrapperComponent>
  );
};
